// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"F8-z"};